export type Lang = 'ru' | 'en';

const STORAGE_KEY = 'headache-maps-lang';

/** UI translations (non-zone text) */
const UI_STRINGS = {
    ru: {
        pageTitle: 'Карта головных болей — узнайте причину вашей боли',
        headerTitle: 'Карта головных болей',
        disclaimer: 'Дисклеймер',
        hintMain: 'Нажмите на светящуюся область головы,<br>чтобы узнать о возможных причинах боли',
        hintSub: 'Вращайте голову мышкой или пальцем',
        wholeHeadBtn: 'Болит вся голова',
        causesTitle: 'Возможные причины',
        remediesTitle: 'Что может помочь',
        doctorTitle: 'Когда обратиться к врачу',
        disclaimerTitle: 'Медицинское предупреждение',
        disclaimerP1: 'Данный сервис предоставляет <strong>только общую справочную информацию</strong> и НЕ является заменой профессиональной медицинской консультации, диагностики или лечения.',
        disclaimerP2: 'При сильной, внезапной или необычной головной боли <strong>немедленно обратитесь к врачу</strong>.',
        disclaimerSources: 'Источники: Mayo Clinic, Cleveland Clinic, WebMD, NHS',
        disclaimerAccept: 'Я понимаю',
        badgeCommon: 'Часто',
        badgeModerate: 'Внимание',
        badgeSerious: 'Серьёзно',
        badgeSelfcare: 'Самопомощь',
        badgeMedication: 'Лекарства',
        badgeProfessional: 'Специалист',
        loading: 'Загрузка 3D модели…',
    },
    en: {
        pageTitle: 'Headache Map — find the cause of your pain',
        headerTitle: 'Headache Map',
        disclaimer: 'Disclaimer',
        hintMain: 'Click on a glowing area of the head<br>to learn about possible causes of pain',
        hintSub: 'Rotate the head with mouse or finger',
        wholeHeadBtn: 'Whole head hurts',
        causesTitle: 'Possible causes',
        remediesTitle: 'What may help',
        doctorTitle: 'When to see a doctor',
        disclaimerTitle: 'Medical disclaimer',
        disclaimerP1: 'This service provides <strong>general reference information only</strong> and is NOT a substitute for professional medical advice, diagnosis, or treatment.',
        disclaimerP2: 'If you have a severe, sudden, or unusual headache, <strong>seek medical attention immediately</strong>.',
        disclaimerSources: 'Sources: Mayo Clinic, Cleveland Clinic, WebMD, NHS',
        disclaimerAccept: 'I understand',
        badgeCommon: 'Common',
        badgeModerate: 'Attention',
        badgeSerious: 'Serious',
        badgeSelfcare: 'Self-care',
        badgeMedication: 'Medication',
        badgeProfessional: 'Specialist',
        loading: 'Loading 3D model…',
    },
};

export type UIStrings = Record<keyof typeof UI_STRINGS.ru, string>;

/** Detect system language, default to 'en' if not Russian */
function detectLang(): Lang {
    const nav = navigator.language || (navigator as { userLanguage?: string }).userLanguage || 'en';
    return nav.toLowerCase().startsWith('ru') ? 'ru' : 'en';
}

/** Get saved or detected language */
export function getCurrentLang(): Lang {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === 'ru' || saved === 'en') return saved;
    return detectLang();
}

/** Save language preference */
export function setLang(lang: Lang): void {
    localStorage.setItem(STORAGE_KEY, lang);
}

/** Get UI strings for a language */
export function t(lang: Lang): UIStrings {
    return UI_STRINGS[lang];
}
